import { Fragment, ReactNode, CSSProperties } from 'react';

export interface SummaryStripItem {
  label: ReactNode;
  value: ReactNode;
  tone?: 'neutral' | 'danger' | 'warning' | 'success';
}

export interface SummaryStripProps {
  items: SummaryStripItem[];
  style?: CSSProperties;
  className?: string;
}

const TONE_COLOR: Record<NonNullable<SummaryStripItem['tone']>, string | undefined> = {
  neutral: undefined,
  danger: 'var(--danger-700)',
  warning: 'var(--warning-700)',
  success: 'var(--success-700)',
};

export function SummaryStrip({ items, style, className = '' }: SummaryStripProps) {
  return (
    <div className={`ds-strip ${className}`.trim()} style={style}>
      {items.map((it, i) => {
        const color = it.tone ? TONE_COLOR[it.tone] : undefined;
        return (
          <Fragment key={i}>
            <span className="ds-strip-item" style={color ? { color } : undefined}>
              {it.label} <b style={color ? { color } : undefined}>{it.value}</b>
            </span>
            {i < items.length - 1 ? <span className="ds-strip-sep">·</span> : null}
          </Fragment>
        );
      })}
    </div>
  );
}

export default SummaryStrip;
